import Model from './Model.js';
export default class ELModel extends Model {
    methods = {};
    events = {};
    handlers = {};
    children = [];
    constructor(model = {}) {
        super(model.attributes ?? {}, model.data ?? {}, model.meta ?? {});
        this.element = model.element;
    }
    /** Adds a child ElementModel to this MODEL */
    addChild(model) {
        this.children.push(model);
        return model;
    }
    /** Adds multiple child ElementModels to this MODEL */
    addChildren(children) {
        children.forEach(child => this.addChild(child));
        return this;
    }
    /** Removes a child ElementModel from this MODEL */
    removeChild(child) {
        this.children = this.children.filter(c => c !== child);
        return this;
    }
    /** Gets all child ElementModels */
    getChildren() {
        return this.children;
    }
    /** Wraps a Synchronous function inside a Promise that returns this element as a callback
        The function is called within a try/catch block and will reject on error
        @param fn An array of Synchronous functions in performing order
        @param msg Optional message to display on error
        @returns Returns this object as a callback
    */
    chain(fn, msg = 'Promise Chain Error') {
        return new Promise((resolve, reject) => {
            try {
                if (Array.isArray(fn)) {
                    fn.map((f, i) => {
                        console.log('function call[' + i + ']', f);
                        f();
                    });
                }
                else {
                    fn();
                }
                resolve(this);
            }
            catch (e) {
                console.warn(msg, e);
                if (e instanceof TypeError) {
                    console.log('Given Array', fn);
                }
                reject(e);
            }
        });
    }
}
